"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveI18nLang = exports.getI18nLang = exports.setI18nLang = exports.i18nRaw = void 0;
var be_1 = __importDefault(require("./plural/be"));
var en_1 = __importDefault(require("./plural/en"));
var id_1 = __importDefault(require("./plural/id"));
var kk_1 = __importDefault(require("./plural/kk"));
var ru_1 = __importDefault(require("./plural/ru"));
var tr_1 = __importDefault(require("./plural/tr"));
var tt_1 = __importDefault(require("./plural/tt"));
var uk_1 = __importDefault(require("./plural/uk"));
var uz_1 = __importDefault(require("./plural/uz"));
var de_1 = __importDefault(require("./plural/de"));
var es_1 = __importDefault(require("./plural/es"));
var hy_1 = __importDefault(require("./plural/hy"));
var ka_1 = __importDefault(require("./plural/ka"));
var ky_1 = __importDefault(require("./plural/ky"));
var sr_1 = __importDefault(require("./plural/sr"));
var fr_1 = __importDefault(require("./plural/fr"));
var lv_1 = __importDefault(require("./plural/lv"));
var lt_1 = __importDefault(require("./plural/lt"));
var ro_1 = __importDefault(require("./plural/ro"));
var fi_1 = __importDefault(require("./plural/fi"));
var az_1 = __importDefault(require("./plural/az"));
var zh_1 = __importDefault(require("./plural/zh"));
var he_1 = __importDefault(require("./plural/he"));
var et_1 = __importDefault(require("./plural/et"));
var no_1 = __importDefault(require("./plural/no"));
var sv_1 = __importDefault(require("./plural/sv"));
var pt_1 = __importDefault(require("./plural/pt"));
var ar_1 = __importDefault(require("./plural/ar"));
var sw_1 = __importDefault(require("./plural/sw"));
var pluralMap = {
    be: be_1.default,
    en: en_1.default,
    id: id_1.default,
    kk: kk_1.default,
    ru: ru_1.default,
    tr: tr_1.default,
    tt: tt_1.default,
    uk: uk_1.default,
    uz: uz_1.default,
    de: de_1.default,
    es: es_1.default,
    hy: hy_1.default,
    ka: ka_1.default,
    ky: ky_1.default,
    sr: sr_1.default,
    fr: fr_1.default,
    lv: lv_1.default,
    lt: lt_1.default,
    ro: ro_1.default,
    fi: fi_1.default,
    az: az_1.default,
    zh: zh_1.default,
    he: he_1.default,
    et: et_1.default,
    no: no_1.default,
    sv: sv_1.default,
    pt: pt_1.default,
    ar: ar_1.default,
    sw: sw_1.default
};
var _langs = ['ru'];
function getDefLang(lang) {
    return ['tr', 'id', 'fi', 'lt', 'pl', 'et', 'lv'].indexOf(lang) === -1 ? 'ru' : 'en';
}
function generateText(template, options) {
    var res = [];
    var len = template.length;
    var pos = 0;
    while (pos < len) {
        var p1 = template.indexOf('{', pos);
        if (p1 === -1) {
            res.push(template.substring(pos));
            return res;
        }
        var p2 = template.indexOf('}', p1);
        if (p2 === -1) {
            res.push(template.substring(pos));
            return res;
        }
        res.push(template.substring(pos, p1), options[template.substring(p1 + 1, p2)]);
        pos = p2 + 1;
    }
    return res;
}
function generateTextWithPlural(plural, options) {
    var lang = _langs.find(function (lang) { return Boolean(pluralMap[lang]); }) || getDefLang(_langs[0]);
    var pluralizer = pluralMap[lang];
    var template = pluralizer(options.count, plural);
    return generateText(template, options);
}
function tr(dictionary, key) {
    var e_1, _a;
    var keyset;
    try {
        for (var _langs_1 = __values(_langs), _langs_1_1 = _langs_1.next(); !_langs_1_1.done; _langs_1_1 = _langs_1.next()) {
            var lang = _langs_1_1.value;
            keyset = dictionary[lang];
            if (keyset && key in keyset)
                return keyset[key];
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_langs_1_1 && !_langs_1_1.done && (_a = _langs_1.return)) _a.call(_langs_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return key;
}
function _i18n(dictionary, key, options) {
    if (options === void 0) { options = {}; }
    var translation = tr(dictionary, key);
    if (typeof translation === 'string') {
        return generateText(translation, options);
    }
    return generateTextWithPlural(translation, options);
}
function i18n(keyset) {
    return function (key, options) {
        if (options === void 0) { options = {}; }
        return _i18n(keyset, key, options).join('');
    };
}
exports.default = i18n;
function i18nRaw(keyset) {
    return function (key, options) {
        if (options === void 0) { options = {}; }
        return _i18n(keyset, key, options);
    };
}
exports.i18nRaw = i18nRaw;
function setI18nLang(lang) {
    _langs = typeof lang === 'string' ? [lang, getDefLang(lang), 'ru'] : lang;
}
exports.setI18nLang = setI18nLang;
function getI18nLang() {
    return _langs[0];
}
exports.getI18nLang = getI18nLang;
function resolveI18nLang(languages, requestLang, requestTld) {
    var language = requestLang;
    if (languages.indexOf(language) === -1) {
        switch (requestTld) {
            case 'com':
                language = 'en';
                break;
            case 'com.tr':
                language = 'tr';
                break;
            default:
                language = 'ru';
        }
    }
    return language;
}
exports.resolveI18nLang = resolveI18nLang;
